export const parseSimpleMarkdown = (markdownText: string) => {
  let html = markdownText
    // Negritas: **texto**
    .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
    // Cursiva: *texto*
    .replace(/\*(.*?)\*/g, "<em>$1</em>")
    // Encabezados: ###, ##, #
    .replace(/^### (.*$)/gim, "<h3>$1</h3>")
    .replace(/^## (.*$)/gim, "<h2>$1</h2>")
    .replace(/^# (.*$)/gim, "<h1>$1</h1>")
    // Listas: - item
    .replace(/^- (.*$)/gim, "<li>$1</li>")
    // Saltos de línea
    .replace(/\n/g, "<br>");

  // Envolvemos listas en <ul>
  if (html.includes("<li>")) {
    html = html.replace(/(<li>.*?<\/li>)/gim, "<ul>$1</ul>");
  }

  // Procesamos tablas
  html = html.replace(/((?:\|.*?\|<br>)+)/g, (tableBlock) => {
    const rows = tableBlock.trim().split("<br>");
    if (rows.length < 2) return tableBlock; // No parece tabla válida

    let header = "";
    let aligns = "";
    let bodyRows = [];

    if (rows.length >= 2 && /^(\|\s*:?-+:?\s*)+\|?$/.test(rows[1])) {
      header = rows[0];
      aligns = rows[1];
      bodyRows = rows.slice(2);
    } else {
      bodyRows = rows;
    }

    const parseRow = (row: string, cellTag = "td") => {
      return (
        "<tr>" +
        row
          .split("|")
          .slice(1, -1) // quitamos primer y último elemento vacíos
          .map((cell) => `<${cellTag}>${cell.trim()}</${cellTag}>`)
          .join("") +
        "</tr>"
      );
    };

    let tableHtml = "<table>";

    if (header && aligns) {
      tableHtml += "<thead>" + parseRow(header, "th") + "</thead>";
    }

    if (bodyRows.length) {
      tableHtml +=
        "<tbody>" +
        bodyRows.map((row) => parseRow(row, "td")).join("") +
        "</tbody>";
    }

    tableHtml += "</table>";
    return tableHtml;
  });

  return html;
};
